import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { SITE } from "@/config/site";
import { SplitWords } from "./Motion";

const colors = ["#FACC15", "#84CC16", "#FF5566", "#8B5CF6"];

export const Process = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 85%", "end 60%"] });
  const scaleX = useTransform(scrollYProgress, [0, 1], [0, 1]);
  return (
  <section id="process" data-testid="process-section" className="scroll-mt-24 bg-[#F7FEE7] py-20 sm:py-28">
    <div className="container-x">
      <h2 className="max-w-3xl font-display text-4xl font-extrabold tracking-[-0.03em] text-slate-900 sm:text-6xl lg:text-7xl">
        <SplitWords text="Four steps from idea to" /> <SplitWords text="launch." delay={0.3} marker="#FF5566" />
      </h2>
      <div ref={ref} className="relative mt-14">
        <div className="absolute left-0 right-0 top-[3.25rem] hidden h-1.5 rounded-full bg-slate-900/10 lg:block" aria-hidden="true">
          <motion.div style={{ scaleX }} className="h-full origin-left rounded-full bg-gradient-to-r from-[#FACC15] via-[#84CC16] via-60% to-[#8B5CF6]" />
        </div>
      <ol className="relative grid gap-5 md:grid-cols-2 lg:grid-cols-4">
        {SITE.process.map((s, i) => (
          <motion.li
            key={s.name}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            data-testid={`process-step-${i + 1}`}
            className="group relative h-full rounded-[28px] border-2 border-slate-900 bg-white p-7 shadow-[6px_6px_0_#0F172A] transition-[transform,box-shadow] duration-300 hover:-translate-x-1 hover:-translate-y-1 hover:shadow-[10px_10px_0_#0F172A]"
          >
              <span className="inline-block font-display text-6xl font-extrabold leading-none transition-transform duration-500 group-hover:-rotate-6 group-hover:scale-110" style={{ color: colors[i % colors.length], WebkitTextStroke: "2px #0F172A" }}>
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="mt-6 font-display text-2xl font-extrabold text-slate-900">{s.name}</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-slate-600">{s.desc}</p>
          </motion.li>
        ))}
      </ol>
      </div>
    </div>
  </section>
  );
};
